import { OutlinedInput } from "@mui/material";

import { useFilterContext } from "../FilterContext";

const FilterItemMaxSpendingRequirement = () => {
  const { filterData, setFilterData } = useFilterContext();

  return (
    <div className="py-[10px]">
      <OutlinedInput
        fullWidth
        type="number"
        value={filterData.maxSpendingRequirement}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setFilterData({
            maxSpendingRequirement: Number(event.target.value),
          });
        }}
      />
    </div>
  );
};

export default FilterItemMaxSpendingRequirement;
